/**
 * AutoDay är en enda sida på roten med hash-vägar (#/kalender). Servern i drift levererar samma sida för
 * alla okända sökvägar, så en gissad adress som https://autoday.se/logout#/kalender öppnar appen – men
 * sökvägen betyder ingenting för appen. Därför:
 *  - sökvägen normaliseras till / och hash (vy, återställningslänk) och frågesträng behålls oförändrade;
 *  - en adress som ser ut som utloggning UTFÖR aldrig något. Appen visar i stället den vanliga vägen
 *    (kontot och knappen Logga ut), så att utloggning alltid är en aktiv handling med befintliga skydd.
 * Native-appen och utvecklingsservern körs redan på /, så där händer ingenting.
 */
export type EntryIntent = 'logout' | null;

const LOGOUT_PATH = /^\/(?:logout|log-out|signout|sign-out|logga-ut|loggaut|utloggning)\/?$/i;

export function entryIntentFor(pathname: string): EntryIntent {
  return LOGOUT_PATH.test(pathname) ? 'logout' : null;
}

/** Ska sökvägen skrivas om till /? Bara roten och /index.html är appens egna sökvägar. */
export function needsNormalizing(pathname: string): boolean {
  return pathname !== '/' && pathname !== '/index.html';
}

export function normalizeEntryPath(loc: Pick<Location, 'pathname' | 'search' | 'hash'> = location, hist: Pick<History, 'replaceState' | 'state'> = history): EntryIntent {
  if (!needsNormalizing(loc.pathname)) return null;
  const intent = entryIntentFor(loc.pathname);
  try {
    hist.replaceState(hist.state, '', '/' + loc.search + loc.hash);
  } catch {
    // Kan inte skriva om adressen (ovanlig inbäddning): appen fungerar ändå, bara adressfältet påverkas.
  }
  return intent;
}
